import "@tql/ui-components-react/global.css";
import "~/styles/global.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { getQueryClient } from "~/shared/services/query-client.ts";
import { initializeMonitoring } from "~/shared/utils/monitoring.ts";

import { App } from "./app.tsx";

// Initialize monitoring/observability
initializeMonitoring();

/* globals document -- browser */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- index.html
const container = document.querySelector("#root")!;
const root = createRoot(container);

root.render(
	<QueryClientProvider client={getQueryClient()}>
		<ReactQueryDevtools initialIsOpen={false} />
		<StrictMode>
			<App />
		</StrictMode>
		<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>,
);
